<template>
  <el-drawer class="drawer fs-drawer fs-bg-wh" :withHeader="false" :show-close="false" :destroy-on-close="true" :visible.sync="is_open" size="90%"
    direction="btt">
    <el-row class="fs-site mt-2">
      <el-col class="fs-credit-content">
        <label class="text-heading--bold">Order #{{ historyitem.orderCode }}</label><br>
        <!-- Delivery Detail -->
        <el-row>
          <el-col>
            <label class="text-heading2" v-if="historyitem.orderType == 2">{{ $t('drawer.paiddetail.pickup') }}</label>
            <label class="text-heading2" v-else>{{ $t('drawer.paiddetail.delivery') }}</label>
            <br><label class="text-heading3">
              <span class="text-heading3--bold">
              {{ $t('pageCheckout.customer') }}: 
              </span>
              <span class="text-heading3">
                {{ historyitem.customerName }} • {{ historyitem.phoneNumber }}
              </span>
            </label><br>
            <label>
              <span class="text-heading3--bold">
              {{ $t('drawer.paiddetail.orderdate') }}: 
              </span>
              <span class="text-heading3">
              {{ historyitem.createDt }}
              </span>
            </label>
            <el-row class="my-2">
              <i class="el-icon-time fs-time"></i>
              <label class="ml--2 text-heading3" v-if="historyitem.deliveryStatus == 8"><em class="fw-lg fs-st-n">{{ $t('pageCheckout.deliverytime') }}: </em>{{ historyitem.receiveDt }} </label>
              <label class="ml--2 text-heading3" v-else><em class="fw-lg fs-st-n">{{ $t('drawer.paiddetail.canceldate') }}: </em>{{ historyitem.cancelTime }} </label>
            </el-row>
          </el-col>
        </el-row>
        <!-- Delivery Address -->
        <el-row class="address" v-if="historyitem.orderType == 3">
          <el-col :span="2" class="text-center">
            <img src="@/assets/icons/thank/from_res.png" class="icon-from">
          </el-col>
          <el-col :span="22">
            <label class="text-body fs-al-sp">{{ historyitem.restaurantName }} {{ $t('pageCheckout.branch') }} {{ historyitem.branchName }}</label>
          </el-col>
        </el-row>
        <el-row v-if="historyitem.orderType == 3">
          <el-col :span="2" class="text-center">
            <img src="@/assets/icons/thank/dot.png" width="2" height="20" class="">
            <el-col :span="22">
            </el-col>
          </el-col>
        </el-row>
        <el-row v-if="historyitem.orderType == 3">
          <el-col :span="2" class="text-center">
            <img src="@/assets/icons/thank/pin.png" class="icon-from">
          </el-col>
          <el-col :span="22">
            <label class="text-body fs-al-sp">{{ historyitem.address }}</label>
          </el-col>
        </el-row>
        <!-- Pickup Address -->
        <el-row class="address" v-if="historyitem.orderType == 2">
          <el-col :span="2" class="text-center">
            <img src="@/assets/icons/thank/from_res.png" class="icon-from">
          </el-col>
          <el-col :span="22">
            <label class="text-body" v-if="historyitem.branchName == '' || historyitem.branchName === null">{{ historyitem.restaurantName }}</label>
            <label class="text-body" v-else>{{ historyitem.restaurantName }} {{ $t('pageCheckout.branch') }} {{ historyitem.branchName }}</label>
          </el-col>
        </el-row>
        <!-- Noti Driver -->
        <el-row class="fs-bd-b py--2" v-if="historyitem.addressNote != ''">
          <label class="text-heading3--bold">{{ $t('drawer.paiddetail.notedriver') }}</label><br>
          <label class="text-heading3 cl-black-ligth">{{ historyitem.addressNote }} ssdsd</label>
        </el-row>
        <!-- List Menu -->
        <el-row class="fs-entry-wrap fs-bd-b py-2" v-for="(menu, index) in historyitem.menus" :key="index">
          <el-col :span="16">
            <label class="text-heading2--med fs-link">x{{ menu.quantity }}</label>
            <label class="text-heading2--med">{{ menu.name }}</label>
            <el-col v-for="(goption,i) in menu.optionGroups" :key="'option-'+i">
              <li class="text-grey text-heading3" v-for="(option,j) in goption.options" :key="'option-'+j">{{ option.name }} {{ (option.quantity > 1) ? 'x' + option.quantity : '' }}</li>
            </el-col>
          </el-col>
          <el-col :span="8" class="text-right">
            <label class="text-heading2--med">{{ menu.price | priceFormat(0,currency) }}</label>
          </el-col>
        </el-row>
        <!-- Total Order -->
        <el-row class="fs-bd-b py-2">
          <el-col :span="16">
            <label class="text-heading3 cl-gray-ligth">{{ $t('pageCheckout.subtotal') }}</label>
          </el-col>
          <el-col :span="8" class="text-right">
            <label class="text-heading3 cl-gray-ligth">{{ historyitem.subTotal | priceFormat(0,currency) }}</label>
          </el-col>
          <el-col :span="24" v-if="historyitem.orderType == 3">
            <el-row>
              <el-col :span="16">
                <!-- delivery -->
                <label class="text-heading3 cl-gray-ligth">{{ $t('suggestion.delivery') }} ({{ historyitem.distance }} km.)</label>
              </el-col>
              <!-- cancel order -->
              <el-col :span="8" class="text-right" v-if="historyitem.deliveryStatus == 100">
                <label class="text-heading3 cl-gray-ligth" v-if="historyitem.fee > 0">{{ historyitem.fee | priceFormat(0,currency) }}</label>
                <label class="fs-price-free float-right" v-else>{{ $t('pageCheckout.free') }}</label>
              </el-col>
              <!-- success order -->
              <el-col :span="8" class="text-right" v-else>
                <label class="text-heading3 cl-gray-ligth" v-if="historyitem.fee > 0">{{ historyitem.fee | priceFormat(0,currency) }}</label>
                <label class="text-heading3 fs-price-free float-right" v-else>{{ $t('pageCheckout.free') }}</label>
              </el-col>
            </el-row>
          </el-col>
          <el-col v-if="BranchDetail.taxType == 'Exclude' && BranchDetail.tax != '0.00' && historyitem.vat != '0.00'">
            <el-row>
              <el-col :span="12">
                <label class="text-heading3 cl-brown-ligth">Vat ({{ BranchDetail.tax | priceFormat }}%)</label>
              </el-col>
              <el-col :span="12" class="text-right">
                <label class="text-heading3 cl-brown-ligth">{{ historyitem.vat | priceFormat(0,currency) }}</label>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="16">
            <label class="text-heading--med">{{ $t('pageCheckout.totalAmount') }}</label>
          </el-col>
          <el-col :span="8" class="text-right">
            <label class="text-heading--med">{{ historyitem.totalAmount | priceFormat(0,currency) }}</label>
          </el-col>
        </el-row>
        <!-- Payment Type -->
        <el-row class="py-2">
          <el-col :span="7">
            <label class="text-body cl-gray-ligth">{{ $t('pageCheckout.payment') }}</label>
          </el-col>
          <el-col :span="17" v-if="historyitem.paymentType == 1">
            <img src="@/assets/icons/thank/cash.png" class="icon-from">
            <label class="text-body ml--2">
              {{ $t('pageCheckout.cod') }}
            </label>
          </el-col>
          <el-col :span="17" v-if="historyitem.paymentType == 17">
            <el-row>
              <el-col class="d-flex align-center" :span="13">
                <img src="@/assets/icons/thank/icon-promptpay.png" class="icon-from">
                <label class="ml--1 text-body">
                  QR
                </label>
              </el-col>
              <el-col :span="11" class="text-right">
                 <label class="text-heading3--med fs-wait" v-if="historyitem.isPaid == 0">• {{ $t('pageOrderListCurrent.waitpayment') }}</label>
                 <label class="text-heading3--med fs-success" v-else>• {{ $t('drawer.paiddetail.paid') }}</label>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="17" v-if="historyitem.paymentType == 18">
            <el-row>
              <el-col :span="13" class="d-flex align-center">
                <img class="fs-credit-icon" :src="'https://images.foodstory.co/' + historyitem.imageCreditCard">
                <label class="ml--1 text-heading3--bold fs-al-sp">
                  **** {{ historyitem.numberCreditCard }}
                </label>
              </el-col>
              <el-col :span="11" class="text-right">
                 <label class="text-heading3--med fs-wait" v-if="historyitem.isPaid == 0">• {{ $t('pageOrderListCurrent.waitpayment') }}</label>
                 <label class="text-heading3--med fs-success" v-else>• {{ $t('drawer.paiddetail.paid') }}</label>
              </el-col>
            </el-row>
          </el-col>
          <el-col :span="17" v-if="historyitem.paymentType == 2">
            <el-row>
              <el-col class="d-flex align-center">
                <img class="mb--1 fs-circle" width="20" height="20" :src="'https://images.foodstory.co/' + historyitem.payment[0].image_key">
                <label class="ml--2 text-heading3">
                  {{ $t('drawer.editorder.transfer') }} {{ historyitem.payment[0].bank_name }}
                </label>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <label class="text-heading3">{{ $t('pageCheckout.accountname') }}: {{ historyitem.payment[0].account_name }}</label>
              </el-col>
              <el-col :span="18">
                 <label>
                   <span class="text-heading3">
                    {{ $t('pageCheckout.accountnumber') }}: 
                   </span>
                   <span class="text-heading2--bold">
                     {{ historyitem.payment[0].account_number }}
                   </span>
                  </label>
              </el-col>
              <!-- <el-col :span="6">
                <el-button plain @click="copyHandle(historyitem.payment[0].account_number)" class="copy-btn">คัดลอก</el-button>
              </el-col> -->
            </el-row>
          </el-col>
        </el-row>
        <!-- Contact Branch -->
        <el-row>
          <el-col :span="24">
            <label class="text-heading2--med">{{ $t('drawer.paiddetail.contactbranch') }}</label>
          </el-col>
        </el-row>
        <el-row class="order-status">
          <el-col :span="contactCol" class="text-center" v-if="BranchDetail.fbMessenger">
            <img class="ico" src="@/assets/icons/thank/messenger.png" @click="openLink(BranchDetail.fbMessenger)">
            <p class="text-heading3 color-black--text">Messenger</p>
          </el-col>
          <el-col :span="contactCol" class="text-center" v-if="BranchDetail.lineName">
            <img class="ico" src="@/assets/icons/thank/line.png" @click="openLink(BranchDetail.lineName,{from:'line',action: 'contact_branch'})">
            <p class="text-heading3 color-black--text">LINE</p>
          </el-col>
          <el-col :span="contactCol" class="text-center" v-if="BranchDetail.phone">
            <a :href="'tel:' + BranchDetail.phone"><img class="ico" src="@/assets/icons/thank/call.png"></a>
            <p class="text-heading3 color-black--text">{{ $t('pageRestaurant.tel') }}</p>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </el-drawer>
</template>
<script>
/* eslint-disable no-unused-vars */
/* eslint-disable vue/no-unused-components */
import Mixins from '@/utils/mixins'

export default {
  name: 'DrawerOrderPaidDetail',
  props: ['historyitem'],
  mixins: [Mixins],
  data() {
    return {
      is_open: true,
      currency: this.$store.getters.currency
    }
  },
  methods: {
    openLink(link,custom) {
      if(link){
        if(custom){
          switch (custom.from) {
            case 'line':
              if(custom.action == "contact_branch"){
                window.open(`https://line.me/R/oaMessage/${link}`)
              }
            break;
            default:
              break;
          }
        }else{
          window.open(link)
        }
      }
    },
    copyHandle(str){
      const el = document.createElement('textarea');  // Create a <textarea> element
      el.value = str;                                 // Set its value to the string that you want copied
      el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
      el.style.position = 'absolute';                 
      el.style.left = '-9999px';                      // Move outside the screen to make it invisible
      document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
      const selected =            
        document.getSelection().rangeCount > 0        // Check if there is any content selected previously
          ? document.getSelection().getRangeAt(0)     // Store selection if found
          : false;                                    // Mark as false to know no selection existed before
      el.select();                                    // Select the <textarea> content
      document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
      document.body.removeChild(el);                  // Remove the <textarea> element
      if (selected) {                                 // If a selection existed before copying
        document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
        document.getSelection().addRange(selected); 
      }
      if (!this.isCopy) {
        this.$notify({
          title: this.$t('pageCheckout.copyaccount'),
          customClass: 'copy-notify',
          iconClass: 'copy-notification',
          duration: 4000,
          type: 'success',
          showClose: false
        });
        this.isCopy = true
        setTimeout(() => {
          this.isCopy = false
        }, 4000);
      }
    }
  },
  computed: {
    BranchDetail () {
      return this.$store.getters.BranchDetail
    },
    contactCol () {
      let contact_list = 0
      if (this.BranchDetail.fbMessenger) {
        contact_list++
      }
      if (this.BranchDetail.lineName) {
        contact_list++
      }
      if (this.BranchDetail.phone) {
        contact_list++
      }
      return 24 / (contact_list || 1)
    }
  },
  watch:{
    is_open(){
      this.$emit('toggle_piad')
    }
  }
};

</script>




// WEBPACK FOOTER //
// src/components/order/DrawerOrderPaidDetail.vue